import { render, staticRenderFns } from "./SolutionListWrapper.vue?vue&type=template&id=1a7a16c3&scoped=true"
import script from "./SolutionListWrapper.vue?vue&type=script&lang=js"
export * from "./SolutionListWrapper.vue?vue&type=script&lang=js"
import style0 from "./SolutionListWrapper.vue?vue&type=style&index=0&id=1a7a16c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a16c3",
  null
  
)

export default component.exports